import { css } from "@emotion/css";

import { UserAuthenticatedLayout } from "@/layouts/AuthenticatedLayout/UserAuthenticatedLayout";
import { Loader } from "@/modules/theme/components/Loader/Loader";
import { PageMeta } from "@/modules/theme/components/PageMeta";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

interface FirstLoadingPageViewProps {
  heading: string;
}

const createFirstLoadingViewStyles = ({ spacing }: Theme) => {
  return {
    root: css({
      position: "relative",
    }),
    heading: css({
      marginBottom: spacing(3),
    }),
    loaderWrapper: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: yellow[400],
      width: "100%",
      height: 400,
    }),
  };
};

export const FirstLoadingPageView = ({
  heading,
}: FirstLoadingPageViewProps) => {
  const classes = createFirstLoadingViewStyles(useTheme());

  return (
    <UserAuthenticatedLayout containerClassName={classes.root}>
      <PageMeta title={heading} />
      <Typography variant="pageHeading" className={classes.heading}>
        {heading}
      </Typography>
      <div className={classes.loaderWrapper}>
        <Loader size={80} variant="primary" />
      </div>
    </UserAuthenticatedLayout>
  );
};
